import { useSelector } from 'react-redux';
import type { ReactNode, VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';

import styles from './IssueContent.module.less';

type ResolvedReasonProps = {
  resolvedAtMessage: string;
  notes: ReactNode;
};

export const ResolvedReason: VoidFunctionComponent<ResolvedReasonProps> = ({ resolvedAtMessage, notes }) => {
  return (
    <div className={styles.resolvedReasonCard}>
      <div className={styles.resolvedReasonHeader}>
        {resolvedAtMessage}
      </div>
      <div className={styles.resolvedReasonNotes}>{notes}</div>
    </div>
  );
};
/**
 * IssueDetailsResolvedReason displays the ignored information
 * of the vulnerability currently being viewed.
 */
const IssueDetailsResolvedReason = () => {
  const isIssueResolved = useSelector(IssuesV2Store.selectors.getIsIssueResolved);
  const resolvedMessage = useSelector(IssuesV2Store.selectors.getIgnoredMessage);
  const resolutionReason = useSelector(IssuesV2Store.selectors.getResolutionReason);
  const resolutionNotes = useSelector(IssuesV2Store.selectors.getResolutionNotes);

  if (!resolvedMessage || !isIssueResolved) {
    return null;
  }

  return (
    <ResolvedReason
      resolvedAtMessage={resolvedMessage}
      notes={
        <>
          {resolutionReason}
          <span className="italic">{resolutionNotes}</span>
        </>
      }
    />
  );
};

export default IssueDetailsResolvedReason;
